module.exports = __webpack_public_path__ + "static/media/futo_mak_forel.3baa3055.webp";